/**
 * Native token definitions for blockchain networks.
 *
 * @remarks
 * Provides standardized IToken definitions for native assets (ETH, SOL)
 * used across the SDK, particularly in the staking module.
 *
 * @packageDocumentation
 */
/**
 * Native Ethereum token definition.
 *
 * @remarks
 * Standard token info for ETH with 18 decimals.
 * Used in Stakewise staking protocol responses.
 */
export const NATIVE_ETH = {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18,
};
/**
 * Native Solana token definition.
 *
 * @remarks
 * Standard token info for SOL with 9 decimals.
 * Used in Solana native staking protocol responses.
 */
export const NATIVE_SOL = {
    name: "Solana",
    symbol: "SOL",
    decimals: 9,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW5zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21haW4vc2hhcmVkL3Rva2Vucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7R0FRRztBQUlIOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBVztJQUNoQyxJQUFJLEVBQUUsVUFBVTtJQUNoQixNQUFNLEVBQUUsS0FBSztJQUNiLFFBQVEsRUFBRSxFQUFFO0NBQ0osQ0FBQztBQUVYOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBVztJQUNoQyxJQUFJLEVBQUUsUUFBUTtJQUNkLE1BQU0sRUFBRSxLQUFLO0lBQ2IsUUFBUSxFQUFFLENBQUM7Q0FDSCxDQUFDIn0=